var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[(!_vm.isWhitelabelHost || !_vm.isHome)?_c('layout-default'):_c('whitelabel-show',{attrs:{"whitelabel":_vm.whitelabel}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }